<div class="company-member-page">
  <ysh-page-header title="Member Account" [backLinkRoute]="backLinkRoute" backLinkLabel="Back to Company"/>
  <div class="panels">
    <ysh-panel
      class="panel"
      heading="Information"
      padding="left-right-bottom">

      <ysh-traits [traits]="memberInfo" imageSrc="assets/images/avatar-default-slate.png"/>
    </ysh-panel>

    @if (canEditRole) {
      <ysh-panel
        class="panel"
        heading="Role"
        padding="all-sides">

        <div class="role-edit">
          <mat-form-field size-small>
            <mat-label>Account Role</mat-label>
            <mat-select [(ngModel)]="selectedRole">
              @for (role of roles; track role) {
                <mat-option [value]="role">{{ role | titlecase }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <ysh-button
            label="Save"
            theme="blue"
            size="small"
            [loading]="savingRole"
            [disabled]="savingRole || !hasRoleChange"
            (click)="handleSaveRole()"
          />
        </div>
      </ysh-panel>
    }
  </div>
</div>
